export enum ZoneStatus {
    Active,
    Inactive
}
